// extracted by mini-css-extract-plugin
export default {"navContainer":"NavBar_navContainer__jHiov","navLinks":"NavBar_navLinks__Yi0zb","downloadButton":"NavBar_downloadButton__gEoCt","downloadIcon":"NavBar_downloadIcon__a-L2I"};